import Vue from 'vue';
import Vuex from 'vuex';

import global from './global';

import versions from '@/modules/versioning/store/';
import navigation from '@/modules/navigation/store/';
import messages from '@/modules/messaging/store/';
import features from '@/modules/featuring/store/';
import { RootStateShape } from 'store';

Vue.use(Vuex);

export default new Vuex.Store<RootStateShape>({
	modules: {
		messages,
		global,
		versions,
		navigation,
		features
	}
});
